import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Destinations from '../components/Destinations';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import WhyUs from '../components/WhyUs';
import Testimonials from '../components/Testimonials';

export default function HomePage() {
  return (
    <>
      <Hero />
      <Stats />
      <Destinations />
      <Services />
      <HowItWorks />
      <WhyUs />
      <Testimonials />
    </>
  );
}
